let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lX3hU")).then(() => parcelRequire('dP4uk'));